import "./../../levels/common.blocks/user-hat/user-hat.react.js";
import _userHat_fetchData_yes from "./../../levels/common.blocks/user-hat/_fetch-data/user-hat_fetch-data_yes.react.js";

var UserHat = _userHat_fetchData_yes.applyDecls();

import "./../../levels/common.blocks/user-hat/user-hat.css";
import "./../../levels/desktop.blocks/user-hat/user-hat.css";


export default UserHat;